// Konfiguracja tabeli „Zadania” na karcie klienta (Panel Handlowca)

import { IWiseTableColumn, IWiseTableParameter, IWiseTableAction } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';

/**
 * Parametry (opcje nad tabelą) – brak
 */
export const getTraderClientCardTasksTableParameters = (
): IWiseTableParameter[] => {
  return [];
};

/**
 * Kolumny tabeli: nazwa zadania, termin realizacji, status
 */
export const getTraderClientCardTasksTableColumns = (
  t: (key: string) => string
): IWiseTableColumn[] => {
  return [
    {
      type: 'icon',
      label: t('Ikona'),
      field_symbol: 'icon',
      align: 'center',
      tooltip: null,
      size: 60
    },
    {
      type: 'text',
      label: t('Nazwa zadania'),
      field_symbol: 'name',
      align: 'left',
      tooltip: null,
      size: 180
    },
    {
      type: 'date',
      label: t('Termin realizacji'),
      field_symbol: 'due_date',
      align: 'center',
      tooltip: null,
      size: 120
    },
    {
      type: 'status',
      label: t('Status'),
      field_symbol: 'status',
      label_field_symbol: 'status_formatted',
      align: 'center',
      tooltip: null,
      size: 100
    }
  ];
};

/**
 * Akcje tabeli – HEADER „Otwórz listę zadań" + NO_CONTEXT „Utwórz" (modal).
 */
export const getTraderClientCardTasksTableActions = (
  t: (key: string) => string
): IWiseTableAction[] => {
  return [
    {
      symbol: null,
      type: 'HEADER',
      label: t('Otwórz listę zadań'),
      style: null,
      method: 'Redirect',
      method_params: {
        command_url: '',
        page_url: '/trader/tasks',
        params_list: 'client_id=:clientId'
      },
      refresh_data_mode: 'NONE'
    },
    {
      symbol: null,
      type: 'NO_CONTEXT',
      label: t('Utwórz'),
      style: 'ACTION_PLUS',
      method: 'OpenModalComponent',
      method_params: {
        command_url: '',
        component_name: 'TraderPanelTasksForm',
        params_list: 'client_id=:clientId'
      },
      refresh_data_mode: 'ONSUCCESS'
    }
  ];
};

/**
 * Parametry do pobierania danych (endpoint /trader/client_tasks)
 */
export const traderClientCardTasksTableLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/clients/:clientId/tasks',
  params_list: null
};
